import React from "react";
import "./SectionTitle.css";

const SectionTitle = (props) => {
  return (
    <div className="main_section_titles">
      <div className="page_title">
        <h2>
          {props.sectitle}
          <span>{props.clrTtle}</span>
        </h2>
      </div>
      <div className="page_desc">
        <p>{props.secDesc}</p>
      </div>
    </div>
  );
};

export default SectionTitle;
